<template>
    <div class="modal fade" id="bugModal" tabindex="-1" role="dialog"
         aria-hidden="true" aria-labelledby="modalDeleteLabel"
         data-backdrop="static" data-keyboard="false">
        <div class="modal-dialog border rounded border-dark" role="document" style="background:white;">
            <div class="modal-content">
                <div class="modal-body" style="background:white;">
                    <div class="container">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <div class="row pb-3">
                            <p class="h4 mx-auto">Report an Issue</p>
                        </div>

                        <div v-if="requiredValidation" class="alert alert-danger" role="alert">
                            Please fill in the required information
                        </div>
                        <div v-else-if="reportSent" class="alert alert-success" role="alert">
                            Report has been sent!
                        </div>

                        <form name="form" method="post" id="report-issue-form">

                            <div class="form-group">
                                <label for="issueBlock">What is the issue?</label>
                                <textarea v-model="request.issue" :class="{ hasError: vErrors && vErrors.issue }"
                                          class="form-control" id="issueBlock" name="issue" rows="3"/>
                            </div>
                            <div class="form-group">
                                <label for="actionBlock">What were you doing when the error occurred?</label>
                                <textarea v-model="request.action" :class="{ hasError: vErrors && vErrors.action }"
                                          class="form-control" id="actionBlock" name="action" rows="3" required/>
                            </div>
                            <div class="form-group">
                                <label for="pageBlock">What page were you viewing?</label>
                                <textarea v-model="request.page_viewed" class="form-control" id="pageBlock"
                                          name="page_viewed" rows="3"/>
                            </div>

                            <div class="row pb-3">
                                <p class="h4 mx-auto">Contact Information</p>
                            </div>
                            <div class="form-group">
                                <label for="mdlName">Name</label>
                                <input v-model="request.name" :class="{ hasError: vErrors && vErrors.name }"
                                       class="form-control" id="mdlName" type="text" placeholder="John Doe">
                            </div>
                            <div class="form-group">
                                <label for="mdlEmail">Email</label>
                                <input v-model="request.email" :class="{ hasError: vErrors && vErrors.email }"
                                       class="form-control" id="mdlEmail" type="email" placeholder="name@example.com">
                                <p v-if="emailValidation" class="text-danger pt-1">
                                    Please enter a valid email address.
                                </p>
                            </div>
                            <div class="form-group mt-3">
                                <slot name="no-captcha-display"></slot>
                            </div>

                            <div v-if="btnText" class="row pb-3">
                                <button @click="submitIssue" type="button" id="buttonId"
                                        class="btn btn-outline-primary mx-auto mb-2">
                                    {{ btnText }}
                                </button>
                            </div>

                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ReportIssueModal",
    data() {
        return {
            vErrors: null,
            btnText: "Send Report",
            reportSent: false,
            request: {
                issue: "",
                action: "",
                page_viewed: "",
                name: "",
                email: ""
            }
        }
    },
    beforeMount() {
        $(window).on("shown.bs.modal", function (e) {
            if (e.target.id === "bugModal" && window.grecaptcha === undefined) {
                const script = document.createElement('script');
                script.src = "https://www.google.com/recaptcha/api.js";
                script.async = true;

                document.head.appendChild(script);
            }
        });
    },
    computed: {
        //checking the errors object for a message which mentions "required"
        //this will be the trigger to display the alert banner at the top of the modal
        requiredValidation: function () {
            let hasError = false;
            if (this.vErrors) {
                for (let errors of Object.values(this.vErrors)) {
                    for (let i = 0; i < errors.length; i++) {
                        if (errors[i].includes("required")) {
                            hasError = true;
                            break;
                        }
                    }
                }
            }
            return hasError;
        },
        //checking if the email was not formatted correctly during validation
        emailValidation: function () {
            let hasError = false;
            if (this.vErrors && this.vErrors.email)
                hasError = (this.vErrors.email[0] === "The email must be a valid email address.");
            return hasError;
        }
    },
    methods: {
        submitIssue: function () {
            this.btnText = "Processing...";
            this.disableElements(true);

            //add the captcha response value to the request payload
            this.request["g-recaptcha-response"] = grecaptcha.getResponse();

            //send request
            axios.post("/reportissue", this.request)
                .then(response => {
                    // console.log(response.data);
                    this.vErrors = null;
                    this.btnText = null;
                    this.reportSent = true;
                })
                .catch(error => {
                    // console.log(error);
                    this.disableElements(false);
                    this.btnText = "Send Report";

                    if (error.response.status === 422)
                        this.vErrors = error.response.data.errors;
                    else
                        this.vErrors = {data: {unexpectedResponse: "There was an unexpected issue with your request."}};
                });
        },
        disableElements: function (readOnly) {
            //prevents the user from interacting with the form
            let elements = document.getElementById("report-issue-form").elements;
            for (let i = 0, len = elements.length; i < len; ++i) {
                elements[i].readOnly = readOnly;
            }
        }
    }
}
</script>

<style scoped>
.hasError {
    border: 1px solid red;
}
</style>
